(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hs-glycol-calculator"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hs-fluid-calculator')) {
  customElements.define('hs-fluid-calculator', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
'use strict';
const root=this;
const el=id=>root.querySelector('[data-hsgc="'+id+'"]');
const fields=['length','capacity','extra','stock','target'];
const fmt=(n,d=2)=>n.toLocaleString('en-US',{minimumFractionDigits:d,maximumFractionDigits:d});
function calculate(v){
  for(const key of fields)if(v[key]===''||v[key]===null||!Number.isFinite(Number(v[key])))throw new Error('Enter a valid number in every field to see your mix.');
  const {length,capacity,extra,stock,target}=Object.fromEntries(fields.map(k=>[k,Number(v[k])]));
  if(length<0||extra<0||capacity<=0)throw new Error('Tubing length and other system volume cannot be negative. Capacity per foot must be greater than zero.');
  if(stock<=0||stock>100||target<0||target>100)throw new Error('Enter a product glycol percentage above 0 and up to 100, and a target from 0 to 100.');
  if(target>stock)throw new Error('This product cannot reach your target by adding water. Choose a product with a higher glycol concentration or lower the target.');
  const tubing=length*capacity,total=tubing+extra;
  if(!Number.isFinite(total)||total<=0)throw new Error('Enter tubing length or other system fluid to create a fill volume greater than zero.');
  const fraction=target/stock,product=total*fraction,water=total-product;
  return {tubing,total,product,water,fraction,target,extra};
}
const glycolHint = el('concentrationHint').innerHTML;
function render(){
  const alphi=el('product').value==='alphi';
  el('stockLabel').textContent=alphi?'Alphi-11 product strength':'Glycol in the product';
  el('targetLabel').textContent=alphi?'Desired final Alphi-11':'Desired final glycol';
  el('finalLabel').textContent=alphi?'FINAL ALPHI-11 PRODUCT CONCENTRATION':'FINAL GLYCOL CONCENTRATION';
  el('finalHint').textContent=alphi?'Percentage of full-strength Alphi-11 in the finished mix.':'Includes the glycol already in your selected product.';
  el('concentrationHint').innerHTML=alphi?'For this option, 35% means 35% full-strength Alphi-11 product + 65% distilled water by volume. The 100% setting identifies undiluted product, not pure glycol. Follow Fernox’s product dilution guidance.':glycolHint;
  try{
    const r=calculate(Object.fromEntries(fields.map(k=>[k,el(k).value])));
    el('error').hidden=true;el('results').hidden=false;
    el('total').textContent=fmt(r.total);el('breakdown').textContent=fmt(r.tubing)+' gal in tubing + '+fmt(r.extra)+' gal in other components';
    el('glycol').textContent=fmt(r.product)+' gal';el('water').textContent=fmt(r.water)+' gal';
    el('productPercent').textContent=fmt(r.fraction*100,1)+'% of fill volume';el('waterPercent').textContent=fmt((1-r.fraction)*100,1)+'% of fill volume';
    el('productBar').style.width=r.fraction*100+'%';el('finalPercent').textContent=fmt(r.target,1)+'%';
    el('batchProduct').textContent=fmt(r.fraction,3)+' gal ('+fmt(r.fraction*128,1)+' fl oz)';
    el('batchWater').textContent=fmt(1-r.fraction,3)+' gal ('+fmt((1-r.fraction)*128,1)+' fl oz)';
    el('mixnote').textContent=r.target===0?'Water-only calculation. Verify whether your system requires corrosion inhibitors.':r.water===0?'Use this product as supplied; no additional distilled water is needed.':'Added water is separate from the water already contained in a premixed product.';
    if(alphi) el('mixnote').textContent=(r.target<25?'Below Fernox’s recommended minimum of 25% product for corrosion protection. ':'')+'This recipe uses Alphi-11 concentrate as supplied. Check the manufacturer’s dilution and protection chart for your application.';
    return {...r,basis:alphi?'Alphi-11 product volume':'actual glycol volume'};
  }catch(e){el('results').hidden=true;el('error').hidden=false;el('error').textContent=e.message;return {error:e.message};}
}
el('calculator').addEventListener('submit',e=>e.preventDefault());
el('calculator').addEventListener('input',render);
el('size').addEventListener('change',()=>{if(el('size').value==='half')el('capacity').value='0.0092';else if(el('size').value==='five')el('capacity').value='0.014';render();});
el('capacity').addEventListener('input',()=>{el('size').value='custom';});
el('product').addEventListener('change',()=>{const preset={alphi:100,cryo:55,premix50:50,premix35:35}[el('product').value];el('stock').value=preset??'';el('stock').readOnly=preset!==undefined;render();});
el('stock').readOnly=true;
render();

    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
